(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFirmwareEnableController',TabFirmwareEnableController);

    TabFirmwareEnableController.$inject = ['$uibModalInstance', 'entity', 'TabFirmware'];

    function TabFirmwareEnableController($uibModalInstance, entity, TabFirmware) {
        var vm = this;
        vm.tabFirmware = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmEnable = function () {
            vm.tabFirmware.isActive = true;
            TabFirmware.update(vm.tabFirmware,
                function () {
                    $uibModalInstance.close(true);
                },
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
